<form [formGroup]="doiMatKhauForm" (submit)="changePassword()">
    <p-dialog [(visible)]="doiMatKhauFlag" [draggable]="true" [style]="{width: '30vw'}" [modal]="true"
        (onHide)="dialogHide($event)" [position]="position" (onShow)="checkShowOldPassword($event)">
        <ng-template pTemplate="header">
            <h3>Đổi mật khẩu</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field" *ngIf="showOldPasswordInput">
                <label for="hovaten">Mật khẩu cũ</label>
                <input id="oldPassword" type="password" pInputText formControlName="oldPassword" autofocus>
            </div>
            <div class="p-field">
                <label for="newPassword">Mật khẩu mới</label>
                <input id="newPassword" type="password" pInputText formControlName="newPassword">
            </div>
            <div class="p-field">
                <label for="reNewPassword">Nhập lại mật khẩu</label>
                <input id="reNewPassword" type="password" pInputText formControlName="reNewPassword">
                <label *ngIf="doiMatKhauForm.controls.reNewPassword.value!=doiMatKhauForm.controls.newPassword.value"
                    style="color: red;">Mật khẩu mới không khớp!!!</label>
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="submit" label="Đổi mật khẩu" class="p-button-raised p-button-text"><i
                    class="fa fa-refresh"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>
<p-toast></p-toast>